import { render, staticRenderFns } from "./v-delivery.vue?vue&type=template&id=7a508289&"
import script from "./v-delivery.vue?vue&type=script&lang=js&"
export * from "./v-delivery.vue?vue&type=script&lang=js&"
import style0 from "./v-delivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports